import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-create-hypermetro",
  "use": "app-icon-create-hypermetro-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"app-icon-create-hypermetro\"><g fill-rule=\"evenodd\"><path d=\"M3 0v15.999h11.001V19h-8v3.999H0V30h14.001v-7.001H8V21h14v1.999h-5.999V30H30v-7.001h-5.999V19h-8v-3.001H27V0H3zm2.001 14h20V2h-20v12zM18 28h10v-3.001H18V28zM2 28h10v-3.001H2V28z\" /><path d=\"M21 12h2v-2h-2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol